exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-text-nested-level-small-box {\n  min-height: 2em;\n  height: 100%;\n  display: block;\n}\n.uu5-bricks-text-nested-level-inline {\n  display: inline;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/text.less
// module id = 278
// module chunks = 0